import { useParams } from "react-router";
import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { prefixUrl } from "../../Utils/utilsData";
import CardBlog from "./CardBlog";
import Title from "../Title/Title";
import Pagination from "../Pagination/Pagination";
const TagPage = () => {
  const { tag } = useParams();
  const [posts, setPosts] = useState([]);
  const [blogPosts, setBlogPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  let PageSize = 9;

  const currentPageData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return blogPosts.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, PageSize, blogPosts]);
  useEffect(() => {
    axios
      .post(`${prefixUrl()}/blog/label.php?label=${tag}`)
      .then((response) => {
        setPosts(response.data.output);
      });
  }, []);

  return (
    <>
      <h1 className="tag-title">نتایج برچسب: {posts?.label}</h1>

      <div className="cardsBlogsPrnt__">
        {posts?.data?.map((v, index) => {
          return <CardBlog blogData={v} key={index} />;
        })}
        <Pagination
          key={59955}
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={blogPosts.length}
          pageSize={PageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </>
  );
};

export default TagPage;
